<template>
  <div class="postavitev-info">
    <div class="info-okvir">
      <div class="postavitev-info-icone">
        <i class="fa fa-info-circle"></i>
      </div>
      <div class="postavitev-info-tekst">
        <p class="modra-barva-info">
          Za spremembo elektronskega naslova je potrebno najprej preklicati vklopljeno
          ePoslovanje in nato vnesti nov elektronski naslov.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoKomponentaEposlovanje'
}
</script>

<style scoped>
.postavitev-info {
  padding-top: 30px !important;
  padding-bottom: 10px;
}

.info-okvir {
  width: 560px;
  height: 85px;
  display: flex;
}

@media only screen and (max-width: 1100px) {
  .info-okvir {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/Eposlovanje/InfoKomponentaEposlovanje.vue